import React from 'react';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const MeetingVideoComponent = ({ stream, noMirror }) => {
  return (
    <>
      {stream ? (
        <video
          className={noMirror ? '' : 'video-mirrored'}
          autoPlay
          playsInline
          ref={(el) => {
            if (el && stream) el.srcObject = stream;
          }}
        />
      ) : (
        <div className='participant-icon-container'>
          <AccountCircleIcon style={{ fontSize: '10rem' }} />
        </div>
      )}
    </>
  );
};

export default React.memo(MeetingVideoComponent);
